import React from 'react';
import { motion } from 'framer-motion';
import { Search, Brain, Users } from 'lucide-react';
const problems = [{
  id: 1,
  icon: Search,
  title: 'The Visibility Void',
  problem: 'Exceptional horror games often get buried by mainstream titles or lost in algorithmic darkness.',
  solution: 'We provide a dedicated spotlight platform specifically for the genre, ensuring your game reaches eyes that are actually looking for it.'
}, {
  id: 2,
  icon: Brain,
  title: 'The Understanding Gap',
  problem: 'Generalist publishers often miss the subtle nuances that make a psychological horror or mystery game truly work.',
  solution: 'Our team consists of genre experts who understand pacing, atmosphere, and narrative tension, offering feedback that actually improves your game.'
}, {
  id: 3,
  icon: Users,
  title: 'The Community Disconnect',
  problem: 'Finding and building a loyal audience for niche horror titles is notoriously difficult for indie developers.',
  solution: 'We plug you directly into our established network of horror enthusiasts, content creators, and mystery lovers.'
}];
export function ValueSection() {
  return <section id="values" className="py-24 bg-shadow relative" data-id="element-155">
      <div className="max-w-7xl mx-auto px-6" data-id="element-156">
        <div className="text-center mb-16" data-id="element-157">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-158">
            Why <span className="text-mystic-500" data-id="element-159">Ombreludique</span>?
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-160">
            We solve the specific challenges that haunt indie horror developers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-161">
          {problems.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-abyss border border-white/5 p-8 rounded-lg hover:border-mystic-500/50 transition-colors group relative overflow-hidden" data-id="element-162">
              <div className="absolute top-0 right-0 w-32 h-32 bg-mystic-600/5 rounded-full blur-3xl -mr-16 -mt-16 transition-opacity group-hover:opacity-100 opacity-0" data-id="element-163" />

              <div className="w-12 h-12 bg-white/5 rounded-lg flex items-center justify-center mb-6 group-hover:bg-mystic-900/30 transition-colors" data-id="element-164">
                <item.icon className="w-6 h-6 text-mystic-400" data-id="element-165" />
              </div>

              <h3 className="text-xl font-serif font-bold text-white mb-4" data-id="element-166">
                {item.title}
              </h3>

              <div className="space-y-4" data-id="element-167">
                <div data-id="element-168">
                  <span className="text-xs font-bold text-red-400/80 uppercase tracking-wider" data-id="element-169">
                    The Problem
                  </span>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-170">{item.problem}</p>
                </div>
                <div className="h-px w-full bg-white/5" data-id="element-171" />
                <div data-id="element-172">
                  <span className="text-xs font-bold text-mystic-400 uppercase tracking-wider" data-id="element-173">
                    Our Solution
                  </span>
                  <p className="text-sm text-gray-300 mt-1" data-id="element-174">{item.solution}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}